import React, { lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { CartProvider } from "./Component/CartContext";
import Header from "./Component/Header";
import Footer from "./Component/Footer";

const Main = lazy(() => import("./Component/Main"));
const Shop = lazy(() => import("./Component/Shop"));
const ProductDetail = lazy(() => import("./Component/ProductDetail"));
const CartPage = lazy(() => import("./Component/CartPage"));
const CheckOut = lazy(() => import("./Component/CheckOut"));
const PaySuccess = lazy(() => import("./Component/SuccessPay"));
const About = lazy(() => import("./Component/About"));
const Contact = lazy(() => import("./Component/Contact"));
const Privacy = lazy(() => import("./Component/Privacy"));
const Terms = lazy(() => import("./Component/Terms"));
const Returns = lazy(() => import("./Component/Returns"));
const Delivery = lazy(() => import("./Component/Delivery"));
const Faqs = lazy(() => import("./Component/Faqs"));
const Cookies = lazy(() => import("./Component/Cookies"));
const PolicyCenter = lazy(() => import("./Component/PolicyCenter"));

function LoadingScreen() {
  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <span className="loading-screen__mark" aria-hidden="true" />
      <span className="sr-only">Loading storefront</span>
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Header />
        <div className="page-shell">
          <Suspense fallback={<LoadingScreen />}>
            <Routes>
              <Route path="/" element={<Main />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shopDetails/:id" element={<ProductDetail />} />
              <Route path="/cartpage" element={<CartPage />} />
              <Route path="/checkout" element={<CheckOut />} />
              <Route path="/payment" element={<PaySuccess />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/returns" element={<Returns />} />
              <Route path="/shipping" element={<Delivery />} />
              <Route path="/faqs" element={<Faqs />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/policies" element={<PolicyCenter />} />
              <Route path="/policies/:policySlug" element={<PolicyCenter />} />
            </Routes>
          </Suspense>
        </div>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
